export default __webpack_public_path__ + "static/media/cao-e-gato-geriox.19281148.jpg";